import { replaceDateObjectWithTimeStamp } from '@modules/common/utils';
import { SearchQuery } from '@modules/feed/types';
import { serializeSearchParams } from '@modules/feed/utils/serializeSearchParams';

export const getSearchParams = ({
  baseCondition,
  duration,
  whereClause,
}: SearchQuery) => {
  const parsedBaseCondition = serializeSearchParams(baseCondition);
  const parsedDuration = serializeSearchParams(
    replaceDateObjectWithTimeStamp(duration),
  );
  const parsedWhereClause = serializeSearchParams(whereClause);

  return `?base=${parsedBaseCondition}&duration=${parsedDuration}&where=${parsedWhereClause}`;
};
